import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InputHelper {
  public fixDigits(target) {
    let maxDigits = 2;
    let v = target.value;
    let dotPos = v.indexOf('.');

    if (dotPos != -1) {
      v = v.substr(0, dotPos + maxDigits + 1);

      //searching dubbed dots
      for (var i = dotPos + 1; i < v.length; i++) {
        if (v[i] == '.') {
          v = v.substr(0, i);
          break;
        }
      }
    }
    target.value = v;
  }

  public integerOnly(target) {
    let maxDigits = 2;
    let v = target.value;
    if (v.length > 0) {
      target.value = v.replace(/[^0-9]/g, '');
    }
  }

  public fixDigitsAndMax(target, maxVal) {
    let maxDigits = 2;
    let v = target.value;
    let dotPos = v.indexOf('.');

    if (dotPos != -1) {
      v = v.substr(0, dotPos + maxDigits + 1);

      //searching dubbed dots
      for (var i = dotPos + 1; i < v.length; i++) {
        if (v[i] == '.') {
          v = v.substr(0, i);
          break;
        }
      }
    }

    if (v == '') target.value = '';
    else if (parseFloat(v) <= maxVal) target.value = v;
    else target.value = maxVal;
  }

  public fixDigitsMinAndMax(target, minVal, maxVal) {
    let maxDigits = 2;
    let v = target.value;
    let dotPos = v.indexOf('.');

    if (dotPos != -1) {
      v = v.substr(0, dotPos + maxDigits + 1);

      //searching dubbed dots
      for (var i = dotPos + 1; i < v.length; i++) {
        if (v[i] == '.') {
          v = v.substr(0, i);
          break;
        }
      }
    }

    if (v == '') target.value = '';
    else if (parseFloat(v) > maxVal) target.value = maxVal;
    else if (parseFloat(v) < minVal) target.value = minVal;
    else target.value = v;
  }

  public allowNumberInputKey(e, allowDecimal: boolean = true) {
    let res = false;

    //var isAllowedDot = allowDecimal && e.key == '.' && (e.target == null || e.target.value.indexOf('.') == -1);
    // Allow: backspace, delete, tab, escape, enter and .
    if (
      e.keyCode == 46 ||
      e.keyCode == 8 ||
      e.keyCode == 9 ||
      e.keyCode == 13 ||
      e.keyCode == 27 ||
      (allowDecimal && e.key == '.') ||
      e.key == '-' ||
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow CTRL+C +V +X
      (e.keyCode === 67 && e.ctrlKey) ||
      (e.keyCode === 86 && e.ctrlKey) ||
      (e.keyCode === 88 && e.ctrlKey) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      res = true;
    }
    //Ensure that it is a number
    else if (
      !((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105))
    ) {
      res = true;
    }

    if (!res) e.preventDefault();

    return res;
  }

  Dec2(num) {
    return Number.parseFloat(num).toFixed(2);
  }
}

export function removeSlashesOnPaste(event: ClipboardEvent): void {
  event.preventDefault();
  const clipboardData: DataTransfer = event.clipboardData || (window as any).clipboardData;
  if (!clipboardData) {
    console.warn('Clipboard data not available.');
    return;
  }

  let pastedText: string = clipboardData.getData('text');

  pastedText = pastedText.replace(/\//g, '');

  const target: HTMLInputElement = event.target as HTMLInputElement;
  if (target) {
    // Ensure text is pasted amongst existing text.
    const start: number = target.selectionStart || 0;
    const end: number = target.selectionEnd || 0;
    const currentValue: string = target.value;
    const newValue: string = currentValue.slice(0, start) + pastedText + currentValue.slice(end);

    target.value = newValue;
    // Trigger an 'input' event so Angular updates the model
    target.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
